import 'emerald-ui/dist/utilities/fontAwesomeStyles.css'; // for some reason importing @fortawesome/fontawesome-svg-core/styles.css directly here does not work
import 'emerald-ui/dist/globals/fonts.css';
import { config } from '@fortawesome/fontawesome-svg-core';
import { ThemeProvider as MaterialThemeProvider } from '@mui/material/styles';
import { GlobalStyle } from 'emerald-ui/dist/GlobalStyle';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { forwarderConfig } from '../globals/ForwarderConfig';
import { TrackingModuleGlobalStyles } from '../globals/TrackingModuleGlobalStyles';
import { theme } from '../styles/theme';
import '../styles/main.css';

config.autoAddCss = false; // Tell Font Awesome to skip adding the CSS automatically since it's being imported above\

const queryClient = new QueryClient();

/** @param {import('next/app').AppProps} props  */
export default function App(props) {
    const {
        Component,
        pageProps
    } = props;

    const router = useRouter();
    const { id: trackingNumber = '' } = router.query;

    useEffect(() => {
        console.log(`tracking-module version ${process.env.APP_VERSION}`);

        /**
         * webpack will not add this code block to a production build
         * https://webpack.js.org/guides/production/#specify-the-mode
         */
        if (process.env.NODE_ENV !== 'production') {
            import('emerald-ui/dist/utilities/consoleProxy').then(({ consoleProxy }) => {
                consoleProxy();
            });
        }
        // Remove the server-side injected CSS.
        const jssStyles = document.querySelector('#jss-server-side');
        if (jssStyles && jssStyles.parentElement) {
            jssStyles.parentElement.removeChild(jssStyles);
        }
    }, []);

    return (
        <>
            <Head>
                <title>{`${process.env.FORWARDER} Tracking ${trackingNumber ? `(${trackingNumber})` : ''}`}</title>
                <link
                    href={forwarderConfig[process.env.FORWARDER].faviconUrl}
                    rel='icon'
                />
            </Head>
            <MaterialThemeProvider theme={theme}>
                <StyledThemeProvider theme={theme}>
                    <QueryClientProvider client={queryClient}>
                        <GlobalStyle />
                        <TrackingModuleGlobalStyles />
                        <Component {...pageProps} />
                    </QueryClientProvider>
                </StyledThemeProvider>
            </MaterialThemeProvider>
        </>
    );
}
